import { Component, OnInit } from '@angular/core';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { AppSettingsService } from '@shared/services/app-settings/app-settings.service';
import { AppSettings } from '@shared/models/settings/app-settings';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { SignalsService } from '@shared/services/signals/signals.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AppService } from 'app/app.service';
import { FlightsService } from '../flight.service';


@Component({
  selector: 'app-filter-flights',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectButtonModule, 
    InputSwitchModule, 
    ButtonModule],
  templateUrl: './filter-flights.component.html',
  styleUrl: './filter-flights.component.scss',
})
export class FilterFlightsComponent implements OnInit {
  constructor(
    private appSettingsService: AppSettingsService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private signalService: SignalsService,
    private flightsService: FlightsService,
    public appService: AppService,
  ) {}

  formatSelection: string = 'local';
  flights: boolean = true;
  deadhead: boolean = true;
  cancelled: boolean = true;
  sortOrder: number = 0; // 0 = Ascending, 1 = Descending
  timeFormatItems?: any[];
  appSettings?: AppSettings;
  sub!: Subscription;
  timestamp: string = '';
  error: boolean = false;
  errorMsg: string = 'At least one filter must be selected';

  ngOnInit(): void {
    this.timeFormatItems = [
      {
        label: 'Local',
        value: 'local',
      },
      {
        label: 'UTC',
        value: 'utc',
      },
    ];

    const appSettings = localStorage.getItem('appSettings');
    if (appSettings) {
      const settings: AppSettings = JSON.parse(appSettings);
      this.appSettings = settings;
      this.flights = settings.filter.flights;
      this.deadhead = settings.filter.deadhead;
      this.cancelled = settings.filter.cancelled;
      this.formatSelection = settings.dateTimeFormatDefault;
      this.sortOrder = settings.sortOrder;
    }
  }

  onSave(): void {
    if (this.flights == false && this.deadhead == false && this.cancelled == false) {
      this.error = true;
    }
    if (this.appSettings) {
      const updatedSettings: AppSettings = {
        dashboardViewDefault: this.appSettings.dashboardViewDefault,
        dateTimeFormatDefault: this.formatSelection,
        filter: {
          flights: this.flights,
          deadhead: this.deadhead,
          cancelled: this.cancelled,
        },
        sortOrder: this.sortOrder
      };
      /**
       * FIX ME: When the userSettings endpoint is working
       * call the post to get the updates */
      this.flightsService.onChangeOfFilterSetting(updatedSettings);
      localStorage.setItem('appSettings', JSON.stringify(updatedSettings));
      //this.sub = this.appSettingsService.postUserSettings(updatedSettings).subscribe({
      this.sub = this.appSettingsService.getUserSettings().subscribe({
        complete: () =>
          this.messageService.add({
            severity: 'success',
            summary: 'Saved',
            detail: 'Settings was saved successfully',
          }),
      });
    }

    this.dialogService.dialogComponentRefMap.forEach((dialog) => {
      this.signalService.settingsChanged$.set(true);
      dialog.destroy();
    });
  }

  onSortOrderClicked(): void {
    this.sortOrder = this.sortOrder === 0 ? 1 : 0;
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
